"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CloudOff2_exports = {};
__export(CloudOff2_exports, {
  default: () => CloudOff2_default
});
module.exports = __toCommonJS(CloudOff2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.5977 7.76953C15.4805 7.17057 15.2656 6.61068 14.9531 6.08984C14.6406 5.58203 14.2565 5.14583 13.8008 4.78125C13.3451 4.40365 12.8372 4.11068 12.2773 3.90234C11.7174 3.69401 11.125 3.58984 10.5 3.58984C9.99219 3.58984 9.4974 3.66146 9.01562 3.80469C8.54688 3.94792 8.11068 4.14323 7.70703 4.39062L8.72266 5.40625C9.32161 5.09375 9.95312 4.95052 10.6172 4.97656C11.2812 4.98958 11.8997 5.17188 12.4727 5.52344C13.0456 5.875 13.4948 6.34375 13.8203 6.92969C14.1589 7.5026 14.3281 8.12109 14.3281 8.78516V9.13672H15.3633C15.9362 9.13672 16.4245 9.34505 16.8281 9.76172C17.2448 10.1654 17.4531 10.6536 17.4531 11.2266C17.4531 11.6172 17.349 11.9753 17.1406 12.3008C16.9453 12.6133 16.6849 12.8607 16.3594 13.043L17.375 14.0391C17.8177 13.7266 18.1693 13.3294 18.4297 12.8477C18.7031 12.3529 18.8398 11.8125 18.8398 11.2266C18.8398 10.3021 18.5273 9.51432 17.9023 8.86328C17.2773 8.19922 16.5091 7.83464 15.5977 7.76953ZM4.25 4.46875L6.16406 6.36328C5.60417 6.38932 5.08333 6.51302 4.60156 6.73438C4.11979 6.96875 3.69661 7.27474 3.33203 7.65234C2.96745 8.01693 2.68099 8.44661 2.47266 8.94141C2.26432 9.4362 2.16016 9.96354 2.16016 10.5234C2.16016 11.0964 2.27083 11.6367 2.49219 12.1445C2.71354 12.6523 3.01302 13.0951 3.39062 13.4727C3.76823 13.8503 4.21094 14.1497 4.71875 14.3711C5.22656 14.5924 5.76693 14.7031 6.33984 14.7031H14.4844L15.8711 16.0898L16.75 15.2109L5.12891 3.58984L4.25 4.46875ZM7.53125 7.75L13.0977 13.2969H6.33984C5.57161 13.2969 4.91406 13.0299 4.36719 12.4961C3.82031 11.9492 3.54688 11.2917 3.54688 10.5234C3.54688 9.75521 3.82031 9.10417 4.36719 8.57031C4.91406 8.02344 5.57161 7.75 6.33984 7.75H7.53125Z",
      fill: "currentColor"
    }
  )
);
const SvgCloudOff2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CloudOff2_default = SvgCloudOff2;
